<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("add") }} {{ $t("loyalty") }} {{ $t("program") }}
      </div>
      <router-link class="btn-blue" to="vouchers"
        >{{ $t("loyalty") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="col-lg-6 col-xl-4">
            <div class="multiselect">
              <multiselect
                v-model="value"
                :options="options"
                placeholder="Select Cinema"
                label="name"
                :multiple="true"
                track-by="name"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="[selectedLoyaltyType.length > 0 ? 'shift-up' : '']"
                >{{ $t("loyalty") }} {{ $tc("type", 1) }}</label
              >
              <b-dropdown
                :text="selectedLoyaltyType"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(loyaltyType, loyaltyTypeIndex) in loyaltyType"
                  :key="loyaltyTypeIndex"
                  @click="onSelectLoyaltyType(loyaltyType)"
                  >{{ loyaltyType }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="[selectedLevel.length > 0 ? 'shift-up' : '']"
                >{{ $t("select") }} Level</label
              >
              <b-dropdown
                :text="selectedLevel"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(levels, levelsIndex) in levels"
                  :key="levelsIndex"
                  @click="onSelectLevel(levels)"
                  >{{ levels }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              {{ $t("minimumpointsforredemption") }}:
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-8 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              {{ $t("maximumpointstoberedeemedpertransaction") }}:
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div class="row mx-0">
              <strong>3.&nbsp;</strong>
              {{ $t("requirementtoenroll") }}
              <b-form-checkbox class="j-checkbox mx-3">
                <div>{{ $t("email") }}</div>
              </b-form-checkbox>
              <b-form-checkbox class="j-checkbox mx-3">
                <div>{{ $t("mobiles") }}</div>
              </b-form-checkbox>
              <b-form-checkbox class="j-checkbox mx-3">
                <div>{{ $t("age") }} {{ $t("proof") }}</div>
              </b-form-checkbox>
              <b-form-checkbox class="j-checkbox mx-3">
                <div>Id {{ $t("proof") }}</div>
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-lg-12 col-xl-12">
            <div class="d-flex">
              <strong>4.&nbsp;</strong>
              <div class="input-material-textarea">
                <textarea
                  rows="5"
                  placeholder="."
                  class="rounded-10"
                ></textarea>
                <label>{{ $t("eligibilitytoenroll") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="h6 w-100 px-3">{{ $t("earnpoints") }}</div>
          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} :</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("pointsfromamount") }}</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("spent") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $t("fb") }}:</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("pointsfromamount") }}</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("spent") }}</span>
            </div>
          </div>
          <div class="h6 w-100 px-3">{{ $t("burnpoints") }}</div>

          <div class="col-lg-6 col-xl-6 mb-3">
            <div class="row mx-0 align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("boxoffice") }} :</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("pointsfromamount") }}</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("spent") }}</span>
            </div>
          </div>

          <div class="col-lg-6 col-xl-6">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $t("fb") }} :</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("pointsfromamount") }}</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("spent") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="row">
          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="d-flex align-items-center">
              <strong>1.&nbsp;</strong>
              <span>{{ $t("earnpointsonlyonnondiscountedamount") }}</span>
              <b-form-checkbox switch class="j-checkbox ml-3"></b-form-checkbox>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 mb-4">
            <div class="row mx-0 align-items-center">
              <strong>2.&nbsp;</strong>
              <span>{{ $t("eligiblewithotheroffers") }}</span>
              <b-form-checkbox switch class="j-checkbox ml-3"></b-form-checkbox>
            </div>
          </div>
          <div class="col-lg-12 col-xl-12 mb-4" style="height: 38px">
            <div class="row mx-0 align-items-center h-100">
              <strong>3.&nbsp;</strong>
              <span>{{ $t("eligibleforfreetickets") }}</span>
              <b-form-checkbox
                switch
                v-model="freeTicket"
                class="j-checkbox ml-3"
              ></b-form-checkbox>

              <b-collapse id v-model="freeTicket">
                <div class="row mx-0 align-items-center ml-4">
                  <div class="input-material-sm">
                    <input type="text" />
                  </div>
                  <div class="mx-2">{{ $t("ticketsper") }}</div>
                  <b-form-select
                    class="select-curve"
                    style="width: 200px"
                    :options="durationList"
                    v-model="selectedDuration"
                  ></b-form-select>
                </div>
              </b-collapse>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12">
            <div class="row align-items-center mx-0">
              <strong>4.&nbsp;</strong>
              {{ $t("showpriority") }}
              <b-form-select
                class="select-curve mx-2"
                style="width: 200px"
                :options="priorityList"
                v-model="selectedPriority"
              ></b-form-select>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="section-title text-uppercase mb-4" style="font-size: 20px">
          {{ $t("prepaidcard") }}
        </div>
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="text" />
              <label>{{ $t("cardname") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="number" />
              <label>{{ $t("cardserialnostart") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="number" />
              <label>{{ $t("cardserialnoends") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  name="fdate"
                  id="fdate"
                  v-validate="'required'"
                ></Datepicker>
                <label class="active">{{ $t("cardvalidityfromdate") }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  name="fdate"
                  id="fdate"
                  v-validate="'required'"
                ></Datepicker>
                <label class="active">{{ $t(cardexpirydate) }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div class="h6 mb-3">Card Offers</div>
            <div class="row mx-0 align-items-center">
              <b-form-checkbox class="j-checkbox" v-model="loadAmount">
                <div>{{ $t("loadamount") }}</div>
              </b-form-checkbox>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>
              <span>{{ $t("getextra") }}</span>
              <div class="input-material-sm mx-2">
                <input type="text" />
              </div>

              <div class="col-12 d-flex pl-4 pt-3" v-if="loadAmount">
                <div class="d-flex align-items-center">
                  <span>{{ $t("maxloadamount") }}</span>
                  <div class="input-material-sm mx-2">
                    <input type="text" />
                  </div>
                </div>
                <div class="d-flex align-items-center mx-4">
                  <span>{{ $t("maxextraamount") }}</span>
                  <div class="input-material-sm mx-2">
                    <input type="text" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <b-form-checkbox class="j-checkbox" v-model="freeMovieOffer">
                <div>{{ $t("freemovieoffer") }}</div>
              </b-form-checkbox>
            </div>

            <b-collapse id class v-model="freeMovieOffer">
              <div class="col-12 pt-3">
                <div class="d-flex align-items-center ml-2">
                  <b-form-checkbox class="j-checkbox">
                    <div>{{ $t("watch") }}</div>
                  </b-form-checkbox>
                  <div class="input-material-sm mx-2">
                    <input type="text" />
                  </div>
                  <div>{{ $t("movie", 1) }},</div>
                  <div class="input-material-sm mx-2">
                    <input type="number" />
                  </div>
                  <span>{{ $t("free") }}</span>
                </div>
              </div>
              <div class="col-12 pt-3">
                <div class="d-flex align-items-center ml-2">
                  <b-form-checkbox class="j-checkbox">
                    <div>{{ $t("spendamount") }}</div>
                  </b-form-checkbox>
                  <div class="input-material-sm mx-2">
                    <input type="text" />
                  </div>
                  <span>{{ $t("for") }}</span>
                  <div class="input-material-sm mx-2">
                    <input type="number" />
                  </div>
                  <span>{{ $t("moviesandget") }}</span>
                  <div class="input-material-sm mx-2">
                    <input type="number" />
                  </div>
                  <span>{{ $t("moviesfree") }}</span>
                </div>
              </div>
            </b-collapse>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-4">
            <b-form-checkbox class="j-checkbox">
              <div>{{ $t("useallloyaltyofferswiththiscard") }}</div>
            </b-form-checkbox>
          </div>

          <div class="col-lg-12 col-xl-12 text-center mt-4">
            <button class="btn-blue">{{ $t("save") }}</button>
          </div>
        </div>
      </div>

      <div class="border rounded-10 p-3 mb-4">
        <div class="section-title text-uppercase mb-4" style="font-size: 20px">
          {{ $t("loyaltycustomer") }}
        </div>
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="text" />
              <label>{{ $tc("customer", 1) }} {{ $t("name") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="number" />
              <label>{{ $t("mobiles") }} {{ $t("no") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="email" />
              <label>{{ $t("emailid") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label
                :class="selectedLoyaltyProgram.length > 0 ? 'shift-up' : ''"
                >{{ $t("selectloyaltyprogram") }}</label
              >
              <b-dropdown
                :text="selectedLoyaltyProgram"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(
                    loyaltyProgramList, loyaltyProgramIndex
                  ) in loyaltyProgramList"
                  :key="loyaltyProgramIndex"
                  @click="selectLoyaltyProgram(loyaltyProgramList)"
                  >{{ loyaltyProgramList }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="number" />
              <label>{{ $t("initialloadamt") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="number" />
              <label>{{ $t("balance") }} {{ $t("amount") }}</label>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  name="fdate"
                  id="fdate"
                  v-validate="'required'"
                ></Datepicker>
                <label class="active">{{ $t("joinedprogramon") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  name="fdate"
                  id="fdate"
                  v-validate="'required'"
                ></Datepicker>
                <label class="active">{{ $t("expirydateifany") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="input-material">
              <input placeholder="." type="email" />
              <label>{{ $t("noofticketpurchased") }}</label>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center">
            <div class="input-material">
              <input placeholder="." type="email" />
              <label>{{ $t("noffamountsaved") }}</label>
            </div>
          </div>
          <div class="col-lg-12 col-xl-12 text-center mt-4">
            <button class="btn-blue">{{ $t("save") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loyaltyProgramList: [
        "Bonus Bucks",
        "Birthday gift",
        "Exclusive offer",
        "5 Ticket Tuesdays",
      ],
      selectedLoyaltyProgram: "",

      loadAmount: false,
      freeMovieOffer: true,

      value: "",
      options: [
        { name: "Inox (Andheri)", language: "JavaScript" },
        { name: "PVR (Malad)", language: "Ruby" },
        { name: "Carnival (Bandra)", language: "Ruby" },
        { name: "Cinepolis (Mumbai)", language: "PHP" },
        { name: "IMAX Gold", language: "Elixir" },
      ],

      loyaltyType: ["CRUD", "Option 2", "Option 3"],
      selectedLoyaltyType: "",

      levels: ["Level 1", "level 2", "Level 3"],
      selectedLevel: "",

      durationList: [
        { value: null, text: "Select Duration" },
        { value: "a", text: "Weekly" },
        { value: "b", text: "Monthly" },
        { value: "c", text: "Yearly" },
      ],
      selectedDuration: null,

      freeTicket: false,

      priorityList: [
        { value: null, text: "Select Priority" },
        { value: "c", text: "No Priority" },
        { value: "a", text: "If Available" },
        { value: "b", text: "First Priority" },
      ],
      selectedPriority: null,
    };
  },
  methods: {
    selectLoyaltyProgram(params) {
      this.selectedLoyaltyProgram = params;
    },
    onSelectLoyaltyType(params) {
      this.selectedLoyaltyType = params;
    },
    onSelectLevel(params) {
      this.selectedLevel = params;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltyComponent/editLoyalty.vue